<script setup lang="ts">
import { AdsIcon } from '@accor/ads-components'
import ArrowSwitchIcon from '@/assets/icons/arrow-switch.svg'

defineProps<{
  canSwitch: boolean
  switchLabel: string
}>()

const emit = defineEmits<{ switch: [] }>()
</script>

<template>
  <div class="user-card">
    <slot name="top" />
    <hr class="user-card__separator" />
    <slot name="bottom" />
    <button v-if="canSwitch" type="button" class="user-card__switch" @click="emit('switch')">
      {{ switchLabel }}
      <AdsIcon :icon="ArrowSwitchIcon" size="sm" />
    </button>
  </div>
</template>

<style lang="scss">
@use '@/styles/variables' as *;

.user-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ads.$ads-spacing-scale-sm;
  padding: ads.$ads-spacing-scale-lg;
  background-color: ads.$ads-primary-container-low;
  border-radius: ads.$ads-border-radius-container-low;

  &__separator {
    width: 100%;
    border: none;
    border-top: 1px solid ads.$ads-loyalty-container-hi;
    margin: 0;
  }

  &__switch {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: stretch;
    gap: ads.$ads-spacing-scale-xs;
    padding-top: ads.$ads-spacing-scale-sm;
    @include ads-sass.link-alternative-01;
    color: ads.$ads-link;
    cursor: pointer;
    background: none;
    border: none;
    padding-inline: 0;
  }
}
</style>
